import React,{Component} from 'react';
import Popup from "reactjs-popup";
import Countdown from 'react-countdown-now';
 

export default class CountdownR extends Component{

    render(){
        const renderer = ({ days,hours, minutes, seconds, completed }) => {
            if (completed) {
              // Render a completed state
              return <h3 className="lined-complete">COMPLETED</h3>;
            } else {
              // Render a countdown
              return (
                <div className="count">
                    <div className="text-group">
                        <h3>{days}</h3>
                        <p>Days</p>
                    </div>
                    <div className="text-group">
                        <h3>{hours}</h3>
                        <p>Hours</p>
                    </div>
                    <div className="text-group">
                        <h3>{minutes}</h3>
                        <p>Minutes</p>
                    </div>
                    <div className="text-group">
                        <h3>{seconds}</h3>
                        <p>Seconds</p>
                    </div>
                </div>                    
                )
            }
          };
                     
        return(
            <div id="countdown">
                <div className="container">
                    <Countdown
                        date={new Date('Jan 01, 2020 0:0:0').getTime()}
                        renderer={renderer}
                    />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Countdown.js